<template lang="pug">
  v-list(ref="navigation")
    v-list-item-group
      template(v-for="(link, index) in items")
        nuxt-link(
          v-if="isVisible(link, $Organization)"
          :to="link.href"
          class="d-flex align-center link"
          exact
          active-class="link--active"
          :class="{ 'link--spacer': link.spacer }"
        )
          v-list-item(
            :key="index"
            class="list__item"
          )
            v-list-item-icon(
              v-if="link.icon"
              class="mr-0"
            )
              e-svg-icon(:name="isRouteActive(link.href) ? link.activeIcon : link.icon")
            v-list-item-title(class="link__text pl-3") {{ $t(link.text) }}
            span(
              v-if="link.isNew"
              class="link__new"
            ) New
            v-img(
              v-if="link.premiumRequired && !$hasProVersion"
              :src="require('~/assets/images/lock.png')"
              :max-width="20"
            )
</template>

<script>
import checkVisibility from '~/mixins/checkVisibility'

export default {
  name: 'ENavigationLinks',
  mixins: [checkVisibility],
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isRouteActive(path) {
      return this.$route.path === path
    }
  }
}
</script>

<style scoped lang="scss"></style>
